import React from 'react';
import { useLocation } from 'react-router-dom';
import BackButton from '../ui/BackButton';

// Pages où le bouton retour n'a pas de sens (page d'accueil).
const HIDE_ON = ['/', '/home'];

// Bouton "Retour" global : rendu une seule fois dans AppLayout, il apparaît
// donc sur TOUTES les pages (public, tableau de bord, administration), sauf l'accueil.
const GlobalBackButton = () => {
  const { pathname } = useLocation();
  if (HIDE_ON.includes(pathname)) return null;
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4" data-testid="global-back-button">
      <BackButton />
    </div>
  );
};

export default GlobalBackButton;
